import React from "react";
import InputComponent from "../../InputComponent";
import PhoneNumberInput from "../../PhoneNumberInput";
import InputComponentReadOnly from "../../InputComponentReadOnly";
import InputComponentV2 from "../../InputComponentV2";
import DatePickerComponentV2 from "../../DatePickerComponentV2";
import DropDownComponentV2 from "../../DropDownComponentV2";
import DropDownComponentSortedV2 from "../../DropDownComponentSortedV2";
import TextFieldComponentV2 from "../../TextFieldComponentV2";

function GeneralInformationPersonalSection(props) {
  const {
    translate,
    firstName,
    handleFirstNameChange,
    lastName,
    handleLastNameChange,
    nickname,
    handleNicknameChange,
    personalEmail,
    handlePersonalEmailChange,
    phoneNumber,
    handlePhoneNumberChange,
    dob,
    handleDobChange,
    age,
    maritalStatus,
    handleMaritalStatusChange,
    livingWith,
    handleLivingWithChange,
    livingWithOther,
    handleLivingWithOther,
    gender,
    handleGenderChange,
    genderOther,
    handleGenderOther,
    sexualOrientation,
    handleSexualOrientationChange,
    sexualOrientationOther,
    handleSexualOrientationOther,
    currentAddress,
    handleCurrentAddressChange,
    city,
    handleCityChange,
    province,
    handleProvinceChange,
    country,
    handleCountryChange,
    nationality,
    handleNationalityChange,
    clientSource,
    handleClientSourceChange,
    passportNumber,
    handlePassportNumberChange,
    visaExpirationDate,
    handleVisaExpirationDateChange,
  } = props;

  return (
    <div style={{ padding: "0px", width: "100%" }}>
      <div style={{ width: "100%", paddingLeft: "0px", paddingRight: "10px", paddingBottom: "30px", display: "flex", flexDirection: "column", flexWrap: "wrap", gap: "20px" }}>
        <div style={{ borderTop: "1px solid #cccccc", paddingTop: "20px", marginTop: "20px" }}>
          <span id="personal-information" style={{ fontSize: "18px", fontWeight: "600" }}>{translate("PersonalInformation")}</span>
        </div>
        <div style={{ width: "100%", paddingRight: "10px", paddingBottom: "10px", display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "20px" }}>
          <InputComponentV2 title={translate("FirstName")} width="250px" value={firstName} onChange={handleFirstNameChange} />
          <InputComponentV2 title={translate("LastName")} width="250px" value={lastName} onChange={handleLastNameChange} />
          <InputComponentV2 title={translate("Nickname")} width="250px" value={nickname} onChange={handleNicknameChange} />
        </div>
        <div style={{ width: "100%", display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "20px", paddingBottom: "10px" }}>
          <InputComponentV2 title={translate("Email")} width="250px" value={personalEmail} onChange={handlePersonalEmailChange} />
          <PhoneNumberInput title={translate("PhoneNumber")} value={phoneNumber} onChange={handlePhoneNumberChange} width="250px" />
          <DatePickerComponentV2 title={translate("Birthday")} width="260px" height="40px" value={dob} onChange={handleDobChange} />
          <InputComponentReadOnly title={translate("AgeNonEditable")} width="250px" value={age} height="40px" />
        </div>
        <div style={{ width: "100%", display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "20px", paddingBottom: "10px", paddingTop: "10px" }}>
          <DropDownComponentV2 api="maritalStatus" title={translate("MaritalStatus")} value={maritalStatus} onChange={handleMaritalStatusChange} width="250px" />
          <DropDownComponentSortedV2 api="relationship" title={translate("LivingWith")} value={livingWith} onChange={handleLivingWithChange} width="250px" />
          {livingWith === "Other" ? <InputComponentV2 title={translate("IfOtherDescribe")} width="250px" value={livingWithOther} onChange={handleLivingWithOther} /> : ""}
          <DropDownComponentV2 api="gender" title={translate("Gender")} value={gender} onChange={handleGenderChange} width="250px" />
          {gender === "Other" ? <InputComponentV2 title={translate("IfOtherGenderDescribe")} width="250px" value={genderOther} onChange={handleGenderOther} /> : ""}
          <DropDownComponentV2 api="sexualOrientation" title={translate("SexualOrientation")} value={sexualOrientation} onChange={handleSexualOrientationChange} width="250px" />
          {sexualOrientation === "other" ? <InputComponent title={translate("IfOtherDescribe")} width="100px" value={sexualOrientationOther} onChange={handleSexualOrientationOther} /> : ""}
        </div>
        <div style={{ width: "100%", display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "20px", paddingBottom: "10px" }}>
          <TextFieldComponentV2 title={translate("PhysicalAddressOfResidence")} value={currentAddress} onChange={handleCurrentAddressChange} width="520px" />
          <div style={{ gap: "10px" }}>
            <div className="block-input-line1" style={{ paddingTop: "3px", display: "flex", flexDirection: "row", gap: "20px", paddingBottom: "20px" }}>
              <InputComponentV2 title={translate("City")} width="250px" value={city} onChange={handleCityChange} />
              <InputComponentV2 title={translate("ProvinceState")} width="250px" value={province} onChange={handleProvinceChange} />
            </div>
            <div style={{ paddingTop: "3px", display: "flex", flexDirection: "row", gap: "20px" }}>
              <DropDownComponentV2 api="countries" title={translate("Country")} value={country} onChange={handleCountryChange} width="250px" />
              <DropDownComponentV2 api="nationalities" title={translate("Nationality")} value={nationality} onChange={handleNationalityChange} width="250px" />
            </div>
          </div>
        </div>
        <div style={{ width: "100%", display: "flex", flexDirection: "row", flexWrap: "wrap", alignContent: "flex-end", alignItems: "flex-end", gap: "20px", paddingBottom: "10px" }}>
          <DropDownComponentSortedV2 api="clientSource" title={translate("ClientSource")} value={clientSource} onChange={handleClientSourceChange} width="250px" />
          <InputComponentV2 title={translate("PassportNumber")} value={passportNumber} onChange={handlePassportNumberChange} width="250px" />
          <DatePickerComponentV2 title={translate("VisaExpirationDate")} width="250px" value={visaExpirationDate} onChange={handleVisaExpirationDateChange} />
        </div>
      </div>
    </div>
  );
}

export default GeneralInformationPersonalSection;
